module.exports = __webpack_public_path__ + "img/157.b8cfc9fc.jpg";